const FILTER_ACTION_ID = 'filter-action';
export { FILTER_ACTION_ID, };
//# sourceMappingURL=filter-constants.js.map